import gameInfo from '../assets/json/gameInfo.json'
import Phaser from 'phaser';
import gameData from './gameData.js';
import FontKeys from './FontKeys';
import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import { setupAnimations } from './Animations';

const fonts = [];
for (let k in FontKeys)
{
    fonts.push(FontKeys[k]);
}

// note: uncomment or change the following based on what you need to load
ABCyaPhaser.Preloader.PreloaderConfig.fonts = fonts;
/**
 * To load multiple image sprites, change this property to an array of Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = [
 * { key: ABCyaPhaser.Images.DEFAULT_ATLAS, atlasURL: 'assets/images/' + ABCyaPhaser.Images.DEFAULT_ATLAS + '.json', path: 'assets/images' }, // default multiatlas
 * { key: "particles", atlasURL: 'assets/images/particles.json', path: 'assets/images' }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = 'assets/images';
/**
 * To load multiple audio sprites, change this property to an array of Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig objects.
 * Note: you should always include an ogg and mp3 file, the game will determine which to use based on compatibility. 
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = [
 * { key: ABCyaPhaser.Audio.DEFAULT_AUDIO_SPRITE, 
 *   jsonURL: 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.json', 
 *   audioURL: [ 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.ogg', 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.mp3' ] }, // default sound sprite
 * { key: "extrasounds", jsonURL: 'assets/sounds/extrasounds.json', audioURL: [ 'assets/sounds/extrasounds.ogg', 'assets/sounds/extrasounds.mp3' ] }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = 'assets/sounds';
/**
 * You can load spine objects here. This can be an object with key, jsonPath, and atlasPath properties, or an array of those objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.spines = [
 * { key: "spine0", jsonPath: "assets/spines/spine0.json", atlasPath: "assets/spines/spine0.atlas" },
 * { key: "spine1", jsonPath: "assets/spines/spine1.json", atlasPath: "assets/spines/spine1.atlas" }
 * ]
 */
//ABCyaPhaser.Preloader.PreloaderConfig.spines = { key: "", jsonPath: "", atlasPath: "" };

ABCyaPhaser.Preloader.PreloaderConfig.startScene = gameData.startScene;

/**
 * Called when the preload function is done.
 * @param {Phaser.Scene} scene the preloader scene
 */
ABCyaPhaser.Preloader.PreloaderConfig.preloadCallback = scene =>
{
    // insert additional preloader functionality here; scene is the preloader scene
    scene.load.multiatlas("piecesData2", "assets/images/chest-sprites.json","assets/images/");
    scene.load.multiatlas("chest-1-2", "assets/images/ChestShut1-2.json","assets/images/");
    scene.load.multiatlas("chest-3-4", "assets/images/ChestShut3-4.json","assets/images/");
    scene.load.multiatlas("chest-5", "assets/images/ChestShut5.json","assets/images/");
    scene.load.multiatlas("chest-6", "assets/images/ChestShut6.json","assets/images/");
    scene.load.multiatlas("chest-7-8", "assets/images/ChestShut7-8.json","assets/images/");
    scene.load.multiatlas("chest-9-10", "assets/images/ChestShut9-10.json","assets/images/");
    scene.load.multiatlas("sharkBite", "assets/images/SharkBite.json","assets/images/");

    scene.events.once(Phaser.Scenes.Events.CREATE, ()=> setupAnimations(scene));
}

(async function handshake()
{
    try
    {
        await ABCyaLib.Environment.instance.doParentHandshake();
    } catch (error)
    {
        console.warn(error);
    }

    console.info("ABCya Game Info:", gameInfo);
    
    // someday might turn this on, which allows the preloader to progress automatically to the game when in the native game app
    //ABCyaPhaser.Preloader.PreloaderConfig.proceedImmediately = ABCyaLib.Environment.instance.platformType == ABCyaLib.Environment.PLATFORM_TYPES.native;

    // note: there is a bug with this script when using it with Webpack. Jake F. and Stephen R. could not figure out the problem.
    // loading the script at this point prevents the issue from appearing
    let s = document.createElement("script");
    s.setAttribute("src", "./libs/Box2dWeb-2.1.a.3.min.js");
    document.head.appendChild(s);
    
    ABCyaPhaser.Misc.initializePhaserGame(1024, 768, gameData.scenes);

    // initialize any functionality in abcya_phaser that has a dependency on abcya_lib 
    ABCyaPhaser.Misc.initializeAbcyaLibDependencies(ABCyaLib);
})();
